import { ucLoginApi, ucApi, aiadEmsApi, ucOrgsApi, tcWechatApi } from './api';

let env;
let defHttp;
let appCode;
let clientId;

export function setEnv(v) {
  env = v;
}

export function getEnv() {
  return env;
}

export function setApi(v) {
  defHttp = v;
}

export function getApi() {
  return {
    ucLoginApi: ucLoginApi(defHttp),
    ucApi: ucApi(defHttp),
    aiadEmsApi: aiadEmsApi(defHttp),
    ucOrgsApi: ucOrgsApi(defHttp),
    tcWechatApi: tcWechatApi(defHttp),
  };
}

export function setAppCode(v) {
  appCode = v;
}

export function getAppCode() {
  return appCode;
}

export function setClientId(v) {
  clientId = v;
}

export function getClientId() {
  return clientId;
}
